import React from 'react'
import clsx from 'clsx'

interface BadgeProps {
  tone?: 'primary' | 'success' | 'warning' | 'error' | 'gray'
  children: React.ReactNode
}

export default function Badge({ tone = 'gray', children }: BadgeProps) {
  return (
    <span
      className={clsx(
        tone === 'primary' && 'badge-primary',
        tone === 'success' && 'badge-success',
        tone === 'warning' && 'badge-warning',
        tone === 'error' && 'badge-error',
        tone === 'gray' && 'badge-gray'
      )}
    >
      {children}
    </span>
  )
}
